module.exports = __webpack_public_path__ + "assets/address-a2de8e.svg";